import { render, staticRenderFns } from "./Bounds.vue?vue&type=template&id=d621dc74&scoped=true"
import script from "./Bounds.vue?vue&type=script&lang=js"
export * from "./Bounds.vue?vue&type=script&lang=js"
import style0 from "./Bounds.vue?vue&type=style&index=0&id=d621dc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d621dc74",
  null
  
)

export default component.exports